export const environment = {
  production: true,
  apiUrl: 'https://invoicingtool.appsqa.tenaris.com',
  //apiUrl: 'https://localhost:44320',
  //apiUrl: 'https://localhost:5001',

  //Google Analytics
  gaTrackingId: 'G-PZ4RF051W0',
  
  msalKeys: {
    clientId: 'e4b0195d-8dc1-4557-9ce6-7a1d0039c665',
    //clientId: '83009754-63a2-4f83-a824-bde0ef2e01c2', // PRUEBA PROD para probar el replace environment
    authority: 'https://login.microsoftonline.com/a054342c-6f8c-4378-ad61-a8ad00f2b736'
  },
  appInsights: {
    instrumentationKey: 'a662ffbf-8bcd-42db-9517-34ffaddb9f8c'
  },
  team: {
    //teamUrl: 'https://amlogin.extranet.tenaris.com/nidp/oauth/nam',
    //clientId: '34deba5d-7269-4f12-9273-e62abb049f64',
    //logoutUrl: 'https://amlogin.extranet.tenaris.com/nidp/app/logout',

    //Prueba OKTA
    teamUrl: 'https://team-qa.tenaris.com',
    clientId: 'ZoEmhxZrlbaUIaij0wOJ413CYotJTu2S',
    logoutUrl: 'https://team-qa.tenaris.com/oidc/logout'
  },
  access: 'team',
  audience: 'gip'
};